import { useConsent } from "../../consent/useConsent";
import { Link } from "react-router-dom";
import { publicAsset } from "../../features/tenantPath";
import { useTenant } from "../../context/TenantContext";
import "./AppFooter.scss";

const ROZVOZY_URL = "https://rozvozy.sk/";

function AppFooter() {
  const { openSettings } = useConsent();
  // Na predajnej stranke (koren rozvozy.sk) cita majitel prevadzky. VOP su
  // podmienky pre stravnikov konkretnej prevadzky -- jemu patri "Pre prevadzky".
  const { mode } = useTenant();
  const predajna = mode === "root";
  // GEO: stranka prevadzky odkazuje na predajnu stranku Rozvozov. Pri vlastnej
  // domene prevadzky je to skutocny spatny odkaz, preto absolutna URL a bez
  // nofollow/noreferrer (referrer ukaze v analytike, odkial navsteva prisla).
  // Bez target="_blank": CRA lint ho bez noreferrer hlasi a CI build by padol.
  const prevadzka = mode === "path" || mode === "host";

  return (
    <footer className="app-footer">
      <div className="app-footer__logo-section">
        {/* root-absolutne: relativne "rozvozy_icon.png" by pod /veteran/kontakt hladalo /veteran/rozvozy_icon.png */}
        {prevadzka ? (
          <a href={ROZVOZY_URL}>
            <img src={publicAsset("rozvozy_icon.png")} height="35" alt="Logo Rozvozy" />
          </a>
        ) : (
          <img src={publicAsset("rozvozy_icon.png")} height="35" alt="Logo Rozvozy" />
        )}
      </div>

      <nav className="app-footer__links" aria-label="Právne informácie">
        {predajna ? (
          <Link to="/pre-prevadzky" className="app-footer__link">
            Pre prevádzky
          </Link>
        ) : (
          <Link
            to="/vop"
            className="app-footer__link"
          >
            VOP
          </Link>
        )}
        <span className="app-footer__sep" aria-hidden="true">·</span>
        <Link
          to="/ochrana-osobnych-udajov"
          className="app-footer__link"
        >
          Ochrana osobných údajov
        </Link>
        <span className="app-footer__sep" aria-hidden="true">·</span>
        <button
          className="app-footer__link app-footer__link--btn"
          onClick={openSettings}
        >
          Nastavenie cookies
        </button>
      </nav>

      <div className="app-footer__credit">
        {prevadzka && (
          <>
            <span>Beží na systéme </span>
            <a href={ROZVOZY_URL} className="app-footer__credit-link">
              Rozvozy
            </a>
            <span className="app-footer__sep" aria-hidden="true"> · </span>
          </>
        )}
        <span>Created by © </span>
        <a
          href="https://www.inver.sk/"
          className="app-footer__credit-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Inver s.r.o.
        </a>
      </div>
    </footer>
  );
}

export default AppFooter;
